import { getToken } from "./user-service";
import fire from "_utils/firebase";
const url = "/api/v1/marketplace";

// get product analytics
export const getProductAnalytics = async (object) => {

  const new_url =
    url +
    "/stats?productId=" +
    object.productId +
    "&mm_yyyy=" +
    object.date +
    "&status=succeeded";


  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();

      // check for errors
      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error("Issue retrieving product analytics.");
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};

// get product analytics
export const getProductTransactions = async (params) => {
  const { productId, status, startDate, endDate, limit = 100, skip = 0, paxName } = params;
  const new_url = `${url}/transactions?productId=${productId}&status=${status}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&skip=${skip}&paxName=${paxName}`;


  return new Promise(async (resolve, reject) => {

    try {

      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();

      // console.log('response : ', json)

      // check for errors
      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error("Issue retrieving product analytics.");
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      resolve(json);
    } catch (e) {
      console.log('error', e)
      reject(e);
    }
  });
};

// get rewards
export const getAirportRewards = async (iata) => {
  const new_url = url + "/products?iata=" + iata;
  const token = await getToken();

  // console.log('getting airport products url:', new_url)

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();

      // check for errors
      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      // console.log('response : ', json)
      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};
//get products for retailer
export const getProductsByRetailerId = async (retailerId) => {
  const new_url = url + "/products/productsByRetailerId/" + retailerId + "?portal=true";
  const token = await getToken();

  // console.log('getting airport products url:', new_url)

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();

      // check for errors
      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      // console.log('response : ', json)
      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};


export const postReward = async (reward) => {
  const new_url = "/api/v1/marketplace/products";

  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "POST",
        body: JSON.stringify(reward),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      let json = await response.json();

      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};

export const editReward = async (reward) => {
  const new_url = "/api/v1/marketplace/products/" + reward._id;

  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "PUT",
        body: JSON.stringify(reward),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });

      let json = await response.json();

      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};

export const deleteReward = async (reward) => {
  const new_url = url + "/products/" + reward._id;

  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "DELETE",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad request details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error deleting the reward"));
    }
  });
};

export const UploadImage = async (image) => {
  var storage = fire.storage();

  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    // create reference
    const uploadTask = storage.ref(`/images/${image.name}`).put(image);

    uploadTask.on(
      "state_changed",
      (snapShot) => {
        // update on progress of upload
      },
      (e) => {
        reject(new Error("Issue uploading Image"));
      },
      () => {
        // upload complete
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            resolve(fireBaseUrl);
          });
      }
    );
  });
};

export const getTransaction = async (id) => {
  const url = "/api/v1/marketplace/transactions?transactionId=" + id;
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad transactions details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error getting transactions"));
    }
  });
};

export const updateTransaction = async (transaction) => {
  const url = "/api/v1/marketplace/transactions";

  //console.log('updating transaction... ', transaction, ' at ', url)

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
        body: JSON.stringify(transaction),
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad transactions details");
      }

      console.log('response ', json);
      resolve(json);

    } catch (e) {
      console.log('error updating transaction', e)
      reject(new Error("error getting transactions"));
    }
  });
};